@if (sites?.length) {
  <div data-automation="site-table-container">
    <table data-automation="site-table" mat-table matSort [dataSource]="dataSource" (matSortChange)="sortData($event)">
      <ng-container matColumnDef="available">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="available">
          {{ 'account.overview.site_availability' | translate }}
        </th>
        <td mat-cell *matCellDef="let site" data-automation="site-table-status">
          <img src="assets/svg-icons/{{ getSiteColor(site) }}.svg" class="images" alt="{{ getSiteColor(site) }}" />
        </td>
      </ng-container>

      <ng-container matColumnDef="displayLabel">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="displayLabel">
          {{ 'account.overview.site_name' | translate }}
        </th>

        <td
          mat-cell
          *matCellDef="let site"
          data-automation="site-table-name"
          class="link"
          (click)="navigateToSite(site.id)"
        >
          {{ site.displayLabel }}
        </td>
      </ng-container>

      <ng-container matColumnDef="controlMode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="controlMode">
          {{ 'account.overview.site_control_mode' | translate }}
        </th>
        <td mat-cell *matCellDef="let site" data-automation="site-table-controlMode">
          {{ site.controlMode ?? '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="bessStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="bessStatus">
          {{ 'account.overview.site_bess_status' | translate }}
        </th>
        <td mat-cell *matCellDef="let site" data-automation="site-table-bessStatus">
          {{ getSiteBessStatus(site.stores) ?? '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="soc">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="soc">
          {{ 'account.overview.site_soc' | translate }}
        </th>
        <td mat-cell *matCellDef="let site" data-automation="site-table-soc">
          {{ site.soc }}
          @if (site.soc !== undefined && site.soc !== null) {
            %
          } @else {
            -
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="sitePower">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="sitePower">
          {{ 'account.overview.site_power' | translate }}
        </th>
        <td mat-cell *matCellDef="let site" data-automation="site-table-sitePower">
          {{ site.power }}
          @if (site.power !== undefined) {
            kW
          } @else {
            -
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="bessPower">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="bessPower">
          {{ 'account.overview.bess_power' | translate }}
        </th>
        <td mat-cell *matCellDef="let site" data-automation="site-table-bessPower">
          {{ storesPower(site?.stores) }} Kw
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let site; columns: displayedColumns" id="{{ 'site-table-' + site.id }}"></tr>
    </table>
  </div>
}
